import { render, staticRenderFns } from "./productCommissionNew.vue?vue&type=template&id=249a3494&scoped=true&"
import script from "./productCommissionNew.vue?vue&type=script&lang=js&"
export * from "./productCommissionNew.vue?vue&type=script&lang=js&"
import style0 from "./productCommissionNew.vue?vue&type=style&index=0&id=249a3494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249a3494",
  null
  
)

export default component.exports